import React, { Component } from "react";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core/";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import _ from "lodash";
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  Col,
  Input,
  Button,
  InputGroup,
} from "reactstrap";
import Fade from "react-reveal/Fade";
import Loader from "../../../../../Global/Loader";
import axios from "axios";
import { TextArea, Checkbox } from "semantic-ui-react";
import { Modal } from "antd";
import TextField from "@mui/material/TextField";
import { withRouter, Link } from "react-router-dom";
import TemplateForms from "./../../../template";
// import Proveedor from "./../components/Proveedor";
// import Consignatario from "./../components/Consignatario";
import { Autocomplete } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import CheckboxM from "@mui/material/Checkbox";
import Tables from "../../../../Components/Table";
import { withNamespaces } from "react-i18next";
import VALIDATION from "../../../../../../validation";
import { Services } from "../../../../../../repositories/clients/Services";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { openNotification } from "../../../../Components/Notification";
import { Popover } from "antd";
import { formatMeasurement } from "../../../../../utils/formatMeasurement";

import "../styles/styles.scss";
import TooltipValidate from "../../../../PurchaseOrder/info/components/CustomEntities/components/tooltip";
import TableCheckComponent from "../../../../Components/TableCheck";

const ValidationService = new VALIDATION();

const TRANSPORT_MODE_CATALOG_OPTION = {
  1: "Ocean",
  2: "Air",
  3: "Inland",
  4: "Rail",
};

let scrollTableFilter = {
  x: 1200,
  y: 400,
};

let scrollTableFilterPoVisibility = {
  x: 700,
  y: 400,
};

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
    },
    "& #custom-autocomplete-label": {
      color: "brown",
    },
  },
  root: {
    backgroundColor: "yellow",
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});

let sistemaDefault = {
  description: "Neurored",
  key: 1,
  text: "Neurored",
  title: "Neurored",
  value: 1,
};

const poFields = [
  "PONumber",
  "LineNo",
  "ItemNo",
  "SupplierName",
  "Description",
  "Status",
  "CustomerName",
  "ConsigneeName",
];

const visibilityFields = [
  "RefCustomer",
  "Status",
  "TransportMode",
  "QTYOrdered",
];

class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonCheckValidateActive: true,
      columnAnt: [
        {
          dataIndex: "PONumber",
          width: 60,
          title: this.props.t("Po_No_Filter"),
          className: "headerTextShipList",
          // fixed: "left",
          render: (value, e) => (
            <Link
              target="_blank"
              to={"/po-detail-view/" + e.POId}
              className="underline-link"
            >
              <span className="linkDetail">{value}</span>
            </Link>
          ),
        },
        {
          dataIndex: "LineNo",
          width: 30,
          title: this.props.t("Line_Filter"),
          className: "headerTextShipList",
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          dataIndex: "ItemNo",
          width: 30,
          title: this.props.t("Item_Filter"),
          className: "headerTextShipList",
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          dataIndex: "Description",
          width: 100,
          title: this.props.t("Description_Filter"),
          className: "headerTextShipList",
          render: (value) => {
            if (value) {
              if (value.length > 40) {
                return (
                  <Tooltip
                    title={
                      <span
                        className="label-euro "
                        style={{ marginLeft: "5px", fontWeight: "normal" }}
                      >
                        {value}
                      </span>
                    }
                    placement="bottom"
                  >
                    <span className="columTableStyle">
                      {value.substring(0, 30)}...
                    </span>
                  </Tooltip>
                );
              } else {
                return <span className="columTableStyle">{value}</span>;
              }
            } else {
              return <span className="columTableStyle"></span>;
            }
          },
        },
        {
          dataIndex: "Status",
          width: 70,
          title: this.props.t("Status_Filter"),
          className: "headerTextShipList",
          render: (value) => (
            <span
              className="columTableStyle"
              style={{ color: "#000a2e", fontWeight: "bold" }}
            >
              {value}
            </span>
          ),
        },
        // {
        //   dataIndex: "CustomerName",
        //   width: "20em",
        //   title: this.props.t("Customer_Filter"),
        //   className: "headerTextShipList",
        //   render: (value) => <span className="columTableStyle">{value}</span>,
        // },
        // {
        //   dataIndex: "SupplierName",
        //   width: "20em",
        //   title: this.props.t("Supplier_Filter"),
        //   className: "headerTextShipList",
        //   render: (value, e) => {
        //     const dataTootipSupplier = {
        //       tooltipValue: e.SupplierNameEuro,
        //       tooltipAddress: e.SupplierAddressEuro,
        //     };
        //     return (
        //       <p className="row divcenter">
        //         <span className="columTableStyle">
        //           {value}{" "}
        //           {value && <TooltipValidate entity={dataTootipSupplier} />}
        //         </span>
        //       </p>
        //     );
        //   },
        // },
        // {
        //   dataIndex: "ConsigneeName",
        //   width: "20em",
        //   title: this.props.t("Consignee_Filter"),
        //   className: "headerTextShipList",
        //   render: (value, e) => {
        //     const dataTootipConsigniee = {
        //       tooltipValue: e.ConsigneeNameEuro,
        //       tooltipAddress: e.ConsigneeAddressEuro,
        //     };
        //     return (
        //       <p className="row divcenter">
        //         <span className="columTableStyle">
        //           {value}
        //           {value && <TooltipValidate entity={dataTootipConsigniee} />}
        //         </span>{" "}
        //       </p>
        //     );
        //   },
        // },
        // {
        //   dataIndex: "PONumber",
        //   width: 150,
        //   title: this.props.t("Entrance_To_Filter"),
        //   className: "headerTextShipList",
        //   render: (value) => <span className="columTableStyle">{value}</span>,
        // },
        {
          dataIndex: "QTYOrdered",
          width: 70,
          title: this.props.t("Qty_Ordered_Filter"),
          className: "headerTextShipList",
          rowClassName: "rowTextShipList",
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          dataIndex: "QTYConfirmed",
          width: 70,
          title: this.props.t("Qty_Confirmed_Filter"),
          className: "headerTextShipList",
          sort: true,
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
      ],
      columns_PurchaceOrder: [
        {
          label: this.props.t("Po_No_Filter"),
          key: "PONumber",
          minWidth: 120,
          align: "center",
          custom: (value) => (
            <Col md={12} xl={12}>
              <Link target="_blank" to={"/po-detail-view/" + value.POId}>
                <span className="linkDetail">{value.PONumber}</span>
              </Link>
            </Col>
          ),
        },
        {
          label: this.props.t("line"),
          key: "LineNo",
          minWidth: 120,
          align: "center",
          // index: true,
        },
        {
          label: this.props.t("Item_Filter"),
          key: "ItemNo",
          minWidth: 120,
          align: "center",
          // index: true,
        },
        {
          label: this.props.t("Description_Filter"),
          key: "Description",
          minWidth: 170,
          align: "center",
        },
        {
          label: this.props.t("Status_Filter"),
          key: "Status",
          minWidth: 190,
          align: "center",
        },
        {
          label: this.props.t("Customer_Filter"),
          key: "CustomerName",
          minWidth: 200,
          align: "center",
        },
        {
          label: this.props.t("Supplier_Filter"),
          key: "SupplierName",
          minWidth: 250,
          align: "center",
          custom: (value) => {
            const dataTootipSupplierNameSumary = {
              tooltipValue: value.SupplierNameEuro,
              tooltipAddress: value.SupplierAddressEuro,
            };
            return (
              <p className="row divcenter">
                <span className="columTableStyle">
                  {value.SupplierName}
                  {value.SupplierName && (
                    <TooltipValidate entity={dataTootipSupplierNameSumary} />
                  )}
                </span>{" "}
              </p>
            );
          },
        },
        {
          label: this.props.t("Consignee_Filter"),
          key: "ConsigneeName",
          minWidth: 250,
          align: "center",
          tooltip: true,
          custom: (value) => {
            const dataTootipConsignieeSumary = {
              tooltipValue: value.ConsigneeNameEuro,
              tooltipAddress: value.ConsigneeAddressEuro,
            };
            return (
              <p className="row divcenter">
                <span className="columTableStyle">
                  {value.ConsigneeName}
                  {value.ConsigneeName && (
                    <TooltipValidate entity={dataTootipConsignieeSumary} />
                  )}
                </span>{" "}
              </p>
            );
          },
        },
        {
          label: this.props.t("Entrance_To_Filter"),
          key: "PONumber",
          minWidth: 200,
          align: "center",
        },
        {
          label: this.props.t("Qty_Ordered_Filter"),
          key: "QTYOrdered",
          minWidth: 200,
          align: "center",
        },
        {
          label: this.props.t("Qty_Confirmed_Filter"),
          key: "QTYConfirmed",
          minWidth: 200,
          align: "center",
        },
      ],
      poActive: false,
      posPOcopy: [],

      visible: false,
      data: {},
      statusId: "",
      value: "",
      TemplateForms,
      createFormsData: [],
      isEdit: false,
      info: {
        TypeOrder: 1,
        OKAM: {},
        DL: {},
        Borders: "",
        Agente: {},
        FreightTermCode: "",
      },
      customerEdit: false,
      catalgoSearch: [],
      loadingInfo: false,
      columns: [
        {
          title: this.props.t("order_ref"),
          dataIndex: "RefCustomer",
          width: 150,
          render: (value, e) => (
            <Link
              target="_blank"
              to={"/so-detail-view/" + e.ServiceOrderId}
              className="underline-link"
            >
              <span className="linkDetail">{value}</span>
            </Link>
          ),
        },
        {
          title: this.props.t("status"),
          dataIndex: "Status",
          width: 70,
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          title: this.props.t("qty_ordered"),
          dataIndex: "QTYOrdered",
          width: 100,
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          title: this.props.t("transport_mode"),
          dataIndex: "TransportMode",
          width: 100,
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
      ],
      columns_OS: [
        {
          label: this.props.t("line"),
          key: "",
          minWidth: 120,
          align: "center",
          index: true,
        },
        {
          label: this.props.t("order_ref"),
          key: "",
          minWidth: 170,
          align: "center",
          // fixed: true,
          custom: (value) => (
            <Col md={12} xl={12}>
              <Link
                target="_blank"
                to={"/so-detail-view/" + value.ServiceOrderId}
              >
                <span className="linkDetail">{value.RefCustomer}</span>
              </Link>
            </Col>
          ),
        },
        {
          label: this.props.t("number"),
          key: "OrderNumber",
          minWidth: 190,
          align: "center",
        },
        {
          label: this.props.t("status"),
          key: "Status",
          minWidth: 120,
          align: "center",
        },
        {
          label: this.props.t("shipper"),
          key: "SupplierName",
          minWidth: 120,
          align: "center",
          tooltip: true,
          tpkey1: "SupplierAddress",
          tpkey2: "SupplierCity",
          tpkey3: "SupplierState",
          tpkey4: "SupplierCountry",
        },
        {
          label: this.props.t("consignee"),
          key: "ConsigneeName",
          minWidth: 120,
          align: "center",
          tooltip: true,
          tpkey1: "ConsigneeAddress",
          tpkey2: "ConsigneeCity",
          tpkey3: "ConsigneeState",
          tpkey4: "ConsigneeCountry",
        },
        {
          label: this.props.t("shipment_ready"),
          key: "ActualCargoReadyDate",
          minWidth: 120,
          align: "center",
        },
        {
          label: this.props.t("gross_weight"),
          key: "GrossWeight",
          minWidth: 120,
          align: "center",
          separador: true,
        },
        {
          label: this.props.t("qty_ordered"),
          key: "QTYOrdered",
          minWidth: 120,
          align: "center",
          separador: true,
        },
        {
          label: this.props.t("must_arrive_on"),
          key: "RequiredDateDestination",
          minWidth: 120,
          align: "center",
        },
      ],

      posPO: [],
      poPurchaseOrderADD: [],

      posList: [],
      addConsolPlan: [],

      leftSearch: "",
      rightSearch: "",

      leftSelectedKeys: [],
      leftSelectedRows: [],

      rightSelectedKeys: [],
      rightSelectedRows: [],
    };
  }

  modifyTitle = async (owner, transportModeSelected, catSentby) => {
    let catSentbyCopy = _.cloneDeep(catSentby);
    let nameInstance = "";

    if (owner) {
      const { NeuroredRoad, NeuroredAirOcean, Revenova } = owner;
      if (transportModeSelected !== 3) {
        if (NeuroredAirOcean) {
          nameInstance = NeuroredAirOcean;
          let exits = catSentbyCopy.find((item) => item.key === 1);
          if (exits) {
            for (let i = 0; i < catSentbyCopy.length; i++) {
              // console.log("catSentbyCopy[i].key", catSentbyCopy[i].key);
              if (catSentbyCopy[i].key === 1) {
                catSentbyCopy[i].title =
                  catSentbyCopy[i].title + " - " + NeuroredAirOcean; // no eliminar
                // catSentbyCopy[i].title;
              }
            }
          }
          catSentbyCopy = catSentbyCopy.filter((item) => item.key !== 2); // Eliminar el elemento con key 2 de sistemaEp
        } else {
          catSentbyCopy = catSentbyCopy.filter((item) => item.key !== 1); // Eliminar el elemento con key 1 de sistemaEp
        }
      } else {
        if (NeuroredRoad) {
          nameInstance = NeuroredRoad;
          let exits = catSentbyCopy.find((item) => item.key === 1);
          if (exits) {
            for (let i = 0; i < catSentbyCopy.length; i++) {
              // console.log("catSentbyCopy[i].key", catSentbyCopy[i].key);
              if (catSentbyCopy[i].key === 1) {
                catSentbyCopy[i].title =
                  catSentbyCopy[i].title + " - " + NeuroredRoad; // no eliminar
                // catSentbyCopy[i].title;
              }
            }
          }
        } else {
          catSentbyCopy = catSentbyCopy.filter((item) => item.key !== 1); // Eliminar el elemento con key 1 de sistemaEp
        }
        if (Revenova) {
          nameInstance = Revenova;
          let exits = catSentbyCopy.find((item) => item.key === 2);
          if (exits) {
            for (let i = 0; i < catSentbyCopy.length; i++) {
              // console.log("catSentbyCopy[i].key", catSentbyCopy[i].key);
              if (catSentbyCopy[i].key === 2) {
                catSentbyCopy[i].title =
                  catSentbyCopy[i].title + " - " + Revenova; // no eliminar
                // catSentbyCopy[i].title;
              }
            }
          }
        } else {
          catSentbyCopy = catSentbyCopy.filter((item) => item.key !== 2); // Eliminar el elemento con key 2 de sistemaEp
        }
      }
    }
    return { catSentbyCopy, nameInstance };
  };

  validateOwner = async (
    ownerName,
    transportModeSelected,
    catalgoSearchProps,
  ) => {
    let { catalgoSearch } = this.state;
    let newcatalgoSearch = _.cloneDeep(
      catalgoSearchProps ? catalgoSearchProps : catalgoSearch,
    );
    let validateNewCatTransportModes = false;
    let newCatTransportModes = [];
    let newCatDLOKAM = [];
    let catSentby = newcatalgoSearch[0]["SistemaEp"];
    let newcatSentby = [];
    const ownerTeamToFilter = ownerName;

    const filteredOwners = newcatalgoSearch[0]["Owner"].filter(
      (owner) => owner.OwnerTeam === ownerTeamToFilter,
    );

    let nameInstance = "";

    if (transportModeSelected) {
      let { catSentbyCopy, nameInstance } = await this.modifyTitle(
        filteredOwners[0],
        transportModeSelected,
        _.cloneDeep(catSentby),
      );
      newcatSentby = catSentbyCopy;
      nameInstance = nameInstance;
      newCatDLOKAM = newcatalgoSearch[0]["ExecutiveXPD"];
    }
    validateNewCatTransportModes = true;
    newCatTransportModes = newcatalgoSearch[0]["CatTransportModes"];

    return {
      validateNewCatTransportModes,
      newCatTransportModes,
      newcatSentby,
      newCatDLOKAM,
    };
  };

  componentDidMount = async () => {
    let catalogoTrasportModeFinal = undefined;
    let newcatSentbyFinal = undefined;

    if (this.props.info.info) {
      let { TemplateForms } = this.state;
      let { OwnerTeam, TransportModeId } = this.props.info.info;

      if (this.props.info.info.OwnerTeam) {
        let {
          validateNewCatTransportModes,
          newCatTransportModes,
          newcatSentby,
        } = await this.validateOwner(
          OwnerTeam,
          TransportModeId,
          this.props.catalgoSearch,
        );
        catalogoTrasportModeFinal = validateNewCatTransportModes
          ? newCatTransportModes
          : undefined;
        newcatSentbyFinal = newcatSentby;
      } else {
        catalogoTrasportModeFinal = [];
      }

      let newTemplateForms = _.cloneDeep(TemplateForms);
      let newInfo = {
        NameCustomers: {
          key: this.props.info.info.CustomerId,
          value: this.props.info.info.CustomerId,
          text: this.props.info.info.CustomerName,
          title: this.props.info.info.CustomerName,
          OwnerTeam: this.props.info.info.OwnerTeam,
        },
        TrasportMode: {
          key: this.props.info.info.TransportModeId,
          value: this.props.info.info.TransportModeId,
          text: this.props.info.info.TransportMode,
          title: this.props.info.info.TransportMode,
        },
        ServiceType: {
          key: this.props.info.info.TypesServiceId,
          value: this.props.info.info.TypesServiceId,
          text: this.props.info.info.ServiceType,
          title: this.props.info.info.ServiceType,
        },
        ShipmentsType: {
          key: this.props.info.info.ShipmentTypeId,
          value: this.props.info.info.ShipmentTypeId,
          text: this.props.info.info.ShipmentType,
          title: this.props.info.info.ShipmentType,
        },
        Incoterm: {
          key: this.props.info.info.IncotermCode,
          value: this.props.info.info.IncotermCode,
          text: this.props.info.info.Incoterm,
          title: this.props.info.info.Incoterm,
        },
        SistemaEp: {
          key: this.props.info.info.SystemId,
          value: this.props.info.info.SystemId,
          text: newcatSentbyFinal
            ? newcatSentbyFinal[0].title
            : this.prop.info.info.SystemName,
          title: newcatSentbyFinal
            ? newcatSentbyFinal[0].title
            : this.props.info.info.SystemName,
        },

        ServiceLevel: {
          key: this.props.info.info.ServiceLevelId,
          value: this.props.info.info.ServiceLevelId,
          text: this.props.info.info.ServiceLevel,
          title: this.props.info.info.ServiceLevel,
        },

        DL: {
          key: this.props.info.info.DLCode,
          value: this.props.info.info.DLCode,
          text: this.props.info.info.DLName,
          title: this.props.info.info.DLName,
          DLCode: this.props.info.info.DLCode,
        },
        OKAM: {
          key: this.props.info.info.OKAMCode,
          value: this.props.info.info.OKAMCode,
          text: this.props.info.info.OKAMName,
          title: this.props.info.info.OKAMName,
          OKAMCode: this.props.info.info.OKAMCode,
        },
        Borders: {
          key: this.props.info.info.BorderId,
          value: this.props.info.info.BorderId,
          text: this.props.info.info.Border,
          title: this.props.info.info.Border,
        },
        Agente: {
          key: this.props.info.info.customsBrokerCode,
          value: this.props.info.info.customsBrokerCode,
          text: this.props.info.info.customsBrokerName,
          title: this.props.info.info.customsBrokerName,
        },
        FreightTermCode: {
          key: this.props.info.info.FreightTermCode,
          value: this.props.info.info.FreightTermCode,
          text: this.props.info.info.freightTerms,
          title: this.props.info.info.freightTerms,
        },

        osLis: this.props.info.oslist,
        poPurchaselist: this.props.info.opList,
        InstruccionesEspecificas: this.props.info.info.SpecialsInstructions,
        Comentarios: this.props.info.info.AdditionalsComments,
        TypeOrder: this.props.info.info.TypeOrder,
      };
      newInfo.TransportPlanId = this.props.info.info.TransportPlanId;
      newInfo.lineCarge =
        this.props.info.info.TypeOrder === 2
          ? this.props.info.opList.length
          : this.props.info.oslist.length;
      newInfo.totalweights = 0;
      newInfo.QTYConfirmated = 0;
      newInfo.TransportOrderNo = this.props.info.info.TransportOrderNo;
      newInfo.TypeOrder = this.props.info.info.TypeOrder;
      newInfo.UserCreateId = this.props.info.info.UserCreateId;

      let infoTotal =
        this.props.info.info.TypeOrder === 2
          ? this.props.info.opList
          : this.props.info.oslist;

      infoTotal.forEach((e, index) => {
        newInfo.QTYConfirmated = newInfo.QTYConfirmated + Number(e.QTYOrdered);
        newInfo.totalweights = newInfo.totalweights + Number(e.GrossWeight);
      });
      let catalogNuevo = [];
      let serviceTypeCat = [];
      let uniqueCatalog = [];

      if (newInfo["TrasportMode"]) {
        catalogNuevo = this.props.catalgoSearch[0]["ServiceTypeList"].filter(
          (e) =>
            e.TransportModeId === newInfo["TrasportMode"].key &&
            e.ServiceTypeId === newInfo["ServiceType"].key,
        );

        uniqueCatalog = Array.from(
          new Map(catalogNuevo.map((item) => [item.key, item])).values(),
        );

        serviceTypeCat = this.props.catalgoSearch[0]["CatServiceTypes"].filter(
          (e) =>
            e[newInfo["TrasportMode"].text] === "1" &&
            e["SystemId"] === newInfo["SistemaEp"].key,
        );
      }

      let statusId = this.props.info.info.StatusId;

      if (
        this.props.info.info.TransportModeId === 3 &&
        (this.props.info.info.TypesServiceId === 2 ||
          this.props.info.info.TypesServiceId === 3)
      ) {
        for (let i = 0; i < newTemplateForms[0]["previewForm"].length; i++) {
          const e = newTemplateForms[0]["previewForm"][i];
          // if (e.id === 'DL' || e.id === 'OKAM'){
          //   newTemplateForms[0]['previewForm'][i].view=true;
          // }

          if (e.id === "Borders" || e.id === "Agente") {
            newTemplateForms[0]["previewForm"][i].view = true;
          }
        }
      } else {
        for (let i = 0; i < newTemplateForms[0]["previewForm"].length; i++) {
          const e = newTemplateForms[0]["previewForm"][i];
          // if (e.id === 'DL' || e.id === 'OKAM'){
          //   newTemplateForms[0]['previewForm'][i].view=true;
          // }

          if (e.id === "Borders" || e.id === "Agente") {
            newTemplateForms[0]["previewForm"][i].view = false;
          }
        }
      }

      for (let i = 0; i < this.props.info.opList.length; i++) {
        const e = this.props.info.opList[i];
        e.hidden = false;
        e.key = e.POItemsId;
        e.Visible = 1;
        e.checked = false;
      }

      this.setState(
        {
          poActive: this.props.info.info.TypeOrder === 2 ? true : false,
          TemplateForms: newTemplateForms,
          customerEdit: this.props.info.oslist.length > 0 ? true : false,
          statusId,
          catalgoSearch: this.props.catalgoSearch,
          posList: this.props.posList,
          posPO: this.props.posPO,
          posPOClone: this.props.posPO,
          loadingInfo: false,
          info: newInfo,
          addConsolPlan: this.props.info.oslist,
          poPurchaseOrderADD: this.props.info.opList,
          rightSelectedKeys: [],
          leftSelectedKeys: [],
          rightSelectedRows: [],
          rightSearch: "",
        },
        () => {
          this.renderForm(false, uniqueCatalog, true, serviceTypeCat);
        },
      );
    }
  };

  componentWillReceiveProps = async (nextProps) => {
    let { TemplateForms } = this.state;
    let newTemplateForms = _.cloneDeep(TemplateForms);
    let catalogoTrasportModeFinal = undefined;
    let newcatSentbyFinal = undefined;
    let InitnewCatDLOKAM = [];

    if (nextProps.info.info.OwnerTeam) {
      let { OwnerTeam, TransportModeId } = nextProps.info.info;

      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        OwnerTeam,
        TransportModeId,
        nextProps.catalgoSearch,
      );
      InitnewCatDLOKAM = newCatDLOKAM;
      catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;
      newcatSentbyFinal = newcatSentby;
    } else {
      catalogoTrasportModeFinal = [];
    }

    let newInfo = {
      NameCustomers: {
        key: nextProps.info.info.CustomerId,
        value: nextProps.info.info.CustomerId,
        text: nextProps.info.info.CustomerName,
        title: nextProps.info.info.CustomerName,
        OwnerTeam: nextProps.info.info.OwnerTeam,
      },
      TrasportMode: {
        key: nextProps.info.info.TransportModeId,
        value: nextProps.info.info.TransportModeId,
        text: nextProps.info.info.TransportMode,
        title: nextProps.info.info.TransportMode,
      },
      ServiceType: {
        key: nextProps.info.info.TypesServiceId,
        value: nextProps.info.info.TypesServiceId,
        text: nextProps.info.info.ServiceType,
        title: nextProps.info.info.ServiceType,
      },
      ShipmentsType: {
        key: nextProps.info.info.ShipmentTypeId,
        value: nextProps.info.info.ShipmentTypeId,
        text: nextProps.info.info.ShipmentType,
        title: nextProps.info.info.ShipmentType,
      },
      ServiceLevel: nextProps.info.info.ServiceLevelId
        ? {
            key: nextProps.info.info.ServiceLevelId,
            value: nextProps.info.info.ServiceLevelId,
            text: nextProps.info.info.ServiceLevel,
            title: nextProps.info.info.ServiceLevel,
          }
        : undefined,
      Incoterm: {
        key: nextProps.info.info.IncotermCode,
        value: nextProps.info.info.IncotermCode,
        text: nextProps.info.info.Incoterm,
        title: nextProps.info.info.Incoterm,
      },
      FreightTermCode: nextProps.info.info.FreightTermCode
        ? {
            key: nextProps.info.info.FreightTermCode,
            value: nextProps.info.info.FreightTermCode,
            text: nextProps.info.info.freightTerms,
            title: nextProps.info.info.freightTerms,
          }
        : undefined,
      SistemaEp: {
        key: nextProps.info.info.SystemId,
        value: nextProps.info.info.SystemId,
        text: newcatSentbyFinal
          ? newcatSentbyFinal[0].title
          : nextProps.info.info.SystemName,
        title: newcatSentbyFinal
          ? newcatSentbyFinal[0].title
          : nextProps.info.info.SystemName,
      },
      DL: nextProps.info.info.DLCode
        ? {
            key: nextProps.info.info.DLCode,
            value: nextProps.info.info.DLCode,
            text: nextProps.info.info.DLName,
            title: nextProps.info.info.DLName,
            DLCode: nextProps.info.info.DLCode,
          }
        : undefined,
      OKAM: nextProps.info.info.OKAMCode
        ? {
            key: nextProps.info.info.OKAMCode,
            value: nextProps.info.info.OKAMCode,
            text: nextProps.info.info.OKAMName,
            title: nextProps.info.info.OKAMName,
            OKAMCode: nextProps.info.info.OKAMCode,
          }
        : undefined,
      Borders: nextProps.info.info.BorderId
        ? {
            key: nextProps.info.info.BorderId,
            value: nextProps.info.info.BorderId,
            text: nextProps.info.info.Border,
            title: nextProps.info.info.Border,
          }
        : undefined,
      Agente: nextProps.info.info.CustomsBrokerId
        ? {
            key: nextProps.info.info.customsBrokerCode,
            value: nextProps.info.info.customsBrokerCode,
            text: nextProps.info.info.customsBrokerName,
            title: nextProps.info.info.customsBrokerName,
          }
        : undefined,
      poPurchaselist: nextProps.info.opList,
      osLis: nextProps.info.oslist,
      InstruccionesEspecificas: nextProps.info.info.SpecialsInstructions,
      Comentarios: nextProps.info.info.AdditionalsComments,
      TypeOrder: nextProps.info.info.TypeOrder,
      TransportOrderNo: nextProps.info.info.TransportOrderNo,
    };

    newInfo.TransportPlanId = nextProps.info.info.TransportPlanId;
    newInfo.lineCarge =
      nextProps.info.info.TypeOrder === 2
        ? nextProps.info.opList.length
        : nextProps.info.oslist.length;
    newInfo.totalweights = 0;
    newInfo.QTYConfirmated = 0;
    newInfo.UserCreateId = nextProps.info.info.UserCreateId;

    let infoTotal =
      nextProps.info.info.TypeOrder === 2
        ? nextProps.info.opList
        : nextProps.info.oslist;

    infoTotal.forEach((e, index) => {
      newInfo.QTYConfirmated = newInfo.QTYConfirmated + Number(e.QTYOrdered);
      newInfo.totalweights = newInfo.totalweights + Number(e.GrossWeight);
    });
    let catalogNuevo = [];
    let serviceTypeCat = [];
    let uniqueCatalog = [];
    let initNewCatServiceLevel = [];

    if (newInfo["TrasportMode"]) {
      catalogNuevo = nextProps.catalgoSearch[0]["ServiceTypeList"].filter(
        (e) =>
          e.TransportModeId === newInfo["TrasportMode"].key &&
          e.SystemId === newInfo["SistemaEp"].key &&
          e.ServiceTypeId === newInfo["ServiceType"].key,
      );

      uniqueCatalog = Array.from(
        new Map(catalogNuevo.map((item) => [item.key, item])).values(),
      );

      serviceTypeCat = nextProps.catalgoSearch[0]["CatServiceTypes"].filter(
        (e) =>
          e[newInfo["TrasportMode"].text] === "1" &&
          e["SystemId"] === newInfo["SistemaEp"].key,
      );

      if (newInfo["ShipmentsType"] && newInfo["ShipmentsType"].key) {
        initNewCatServiceLevel = nextProps.catalgoSearch[0][
          "ServiceLevel"
        ].filter(
          (e) =>
            e.TransportModeId === newInfo["TrasportMode"].key &&
            e.ServiceTypeId === newInfo["ServiceType"].key &&
            e.CatShipmentTypeId === newInfo["ShipmentsType"].key,
        );
      }
    }

    let customerEdit = nextProps.info.oslist.length > 0 ? true : false;
    let isEdit = nextProps.isEdit ? true : false;

    if (nextProps.info.info.TransportModeId === 3) {
      for (
        let i = 0;
        i <
        newTemplateForms[0][
          isEdit
            ? customerEdit === true
              ? "editCustomer"
              : "edit"
            : "previewForm"
        ].length;
        i++
      ) {
        const e =
          newTemplateForms[0][
            isEdit
              ? customerEdit === true
                ? "editCustomer"
                : "edit"
              : "previewForm"
          ][i];

        if (e.id === "SistemaEp") {
          newTemplateForms[0][
            isEdit
              ? customerEdit === true
                ? "editCustomer"
                : "edit"
              : "previewForm"
          ][i].hidden = false;
        }

        if (
          nextProps.info.info.TypesServiceId === 2 ||
          nextProps.info.info.TypesServiceId === 3
        ) {
          if (e.id === "Borders" || e.id === "Agente") {
            newTemplateForms[0][
              isEdit
                ? customerEdit === true
                  ? "editCustomer"
                  : "edit"
                : "previewForm"
            ][i].view = true;
          }
        } else {
          if (e.id === "Borders" || e.id === "Agente") {
            newTemplateForms[0][
              isEdit
                ? customerEdit === true
                  ? "editCustomer"
                  : "edit"
                : "previewForm"
            ][i].view = false;
          }
        }
      }
    } else {
      for (
        let i = 0;
        i <
        newTemplateForms[0][
          isEdit
            ? customerEdit === true
              ? "editCustomer"
              : "edit"
            : "previewForm"
        ].length;
        i++
      ) {
        const e =
          newTemplateForms[0][
            isEdit
              ? customerEdit === true
                ? "editCustomer"
                : "edit"
              : "previewForm"
          ][i];

        if (e.id === "SistemaEp") {
          newTemplateForms[0][
            isEdit
              ? customerEdit === true
                ? "editCustomer"
                : "edit"
              : "previewForm"
          ][i].hidden = true;
        }
        if (e.id === "Borders" || e.id === "Agente") {
          newTemplateForms[0][
            isEdit
              ? customerEdit === true
                ? "editCustomer"
                : "edit"
              : "previewForm"
          ][i].view = false;
        }
      }
    }

    if (nextProps.info.info.FreightTermCode) {
      for (
        let i = 0;
        i <
        newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"]
          .length;
        i++
      ) {
        const e =
          newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"][
            i
          ];
        if (e.id === "FreightTermCode") {
          newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"][
            i
          ].selectCatalogName =
            TRANSPORT_MODE_CATALOG_OPTION[nextProps.info.info.TransportModeId];
        }
      }
    } else {
      for (
        let i = 0;
        i <
        newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"]
          .length;
        i++
      ) {
        const e =
          newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"][
            i
          ];
        if (e.id === "FreightTermCode") {
          newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"][
            i
          ].selectCatalogName =
            TRANSPORT_MODE_CATALOG_OPTION[nextProps.info.info.TransportModeId];
        }
      }
    }

    let statusId = nextProps.info.info.StatusId;

    for (let i = 0; i < nextProps.info.opList.length; i++) {
      const e = nextProps.info.opList[i];
      e.hidden = false;
      e.key = e.POItemsId;
      e.Visible = 1;
      e.checked = false;
    }
    this.setState(
      {
        poActive: nextProps.info.info.TypeOrder === 2 ? true : false,
        TemplateForms: newTemplateForms,
        customerEdit,
        statusId,
        catalgoSearch: nextProps.catalgoSearch,
        posList: nextProps.posList,
        loadingInfo: false,
        info: newInfo,
        posPO: nextProps.posPO,
        posPOClone: nextProps.posPO,
        addConsolPlan: nextProps.info.oslist,
        isEdit: nextProps.isEdit,
        poPurchaseOrderADD: nextProps.info.opList,
        rightSelectedKeys: [],
        leftSelectedKeys: [],
        rightSelectedRows: [],
        rightSearch: "",
      },
      () => {
        this.renderForm(
          this.state.isEdit,
          uniqueCatalog,
          true,
          serviceTypeCat,
          catalogoTrasportModeFinal,
          newcatSentbyFinal,
          InitnewCatDLOKAM,
          initNewCatServiceLevel,
        );
      },
    );
  };

  handleChange = (name) => async (event) => {
    let { info, isEdit, catalgoSearch } = this.state;
    info[name] = event.target.value;
    let InitnewCatDLOKAM = [];
    let initNewCatServiceLevel = [];

    let transportModeSelected = info["TrasportMode"]
      ? info["TrasportMode"].key
      : undefined;

    let {
      validateNewCatTransportModes,
      newCatTransportModes,
      newcatSentby,
      newCatDLOKAM,
    } = await this.validateOwner(
      info.NameCustomers.OwnerTeam,
      transportModeSelected,
    );
    InitnewCatDLOKAM = newCatDLOKAM;
    let catalogoTrasportModeFinal = validateNewCatTransportModes
      ? newCatTransportModes
      : undefined;

    let catalogNuevo = [];
    let serviceTypeCat = [];
    let uniqueCatalog = [];

    if (info["TrasportMode"]) {
      if (
        info["TrasportMode"] !== undefined &&
        info["ServiceType"] !== undefined
      ) {
        catalogNuevo = catalgoSearch[0]["ServiceTypeList"].filter(
          (e) =>
            e.TransportModeId === info["TrasportMode"].key &&
            e.ServiceTypeId === info["ServiceType"].key,
        );
        uniqueCatalog = Array.from(
          new Map(catalogNuevo.map((item) => [item.key, item])).values(),
        );
      }
      serviceTypeCat = catalgoSearch[0]["CatServiceTypes"].filter(
        (e) =>
          e[info["TrasportMode"].text] === "1" &&
          e.SystemId === info["SistemaEp"].key,
      );
    }
    if (info["ShipmentsType"] && info["ShipmentsType"].key) {
      initNewCatServiceLevel = catalgoSearch[0]["ServiceLevel"].filter(
        (e) =>
          e.TransportModeId === info["TrasportMode"].key &&
          e.ServiceTypeId === info["ServiceType"].key &&
          e.CatShipmentTypeId === info["ShipmentsType"].key,
      );
    }

    this.setState({ info, buttonCheckValidateActive: true }, () =>
      // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat)
      this.renderForm(
        isEdit,
        uniqueCatalog,
        true,
        serviceTypeCat,
        catalogoTrasportModeFinal,
        newcatSentby,
        InitnewCatDLOKAM,
        initNewCatServiceLevel,
      ),
    );
  };

  handleChangeSearch = async (evt, data, id) => {
    let { info, catalgoSearch, isEdit } = this.state;
    let catalogNuevo = [];
    let serviceTypeCat = [];
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let newTemplateForms = _.cloneDeep(TemplateForms);
    let InitnewCatDLOKAM = [];
    document.getElementById("loader0").style.display = "none";
    document.getElementById("loader1").style.display = "none";
    document.getElementById("loaderActive").style.display = "block";

    // if (info["TrasportMode"]) {
    //   serviceTypeCat = catalgoSearch[0]["CatServiceTypes"].filter(
    //     (e) => e[info["TrasportMode"].text] === "1" && e.SystemId === info["SistemaEp"].key
    //   );
    // }

    if (data) {
      let IdCustomer = data.key;
      let codeEP = data.codeEp;
      info["Agente"] = undefined;
      info[""] = undefined;
      info["ShipmentsType"] = undefined;
      info["ServiceType"] = undefined;
      info["Borders"] = undefined;
      info["SistemaEp"] = sistemaDefault;
      info["FreightTermCode"] = undefined;
      info["TrasportMode"] = undefined;
      info["OKAM"] = undefined;
      info["DL"] = undefined;
      info["ServiceLevel"] = undefined;

      for (let i = 0; i < newTemplateForms[0].create.length; i++) {
        const e = newTemplateForms[0].create[i];
        if (e.id === "FreightTermCode") {
          newTemplateForms[0].create[i].selectCatalogName = "Freight";
        }
      }

      info[id] = data;
      let { posList, posPO, catAgente, posPOcopy } = await this.getOrdersTo(
        IdCustomer,
        codeEP,
      );
      catalgoSearch[0].CatAgente = catAgente;
      info["osLis"] = [];
      info["poPurchaselist"] = [];
      let newCatTransportModes = [];
      let validateNewCatTransportModes = false;
      let newcatSentby = undefined;

      let validateOwner = await this.validateOwner(data.OwnerTeam);
      validateNewCatTransportModes = validateOwner.validateNewCatTransportModes;
      newCatTransportModes = validateOwner.newCatTransportModes;
      newcatSentby = validateOwner.newcatSentby;
      InitnewCatDLOKAM = validateOwner.newCatDLOKAM;

      this.setState(
        {
          TemplateForms: newTemplateForms,
          buttonCheckValidateActive: true,
          info,
          posList,
          posPO,
          posPOcopy,
          posPOClone: _.cloneDeep(posPO),
          addConsolPlan: [],
          poPurchaseOrderADD: [],
          poPurchaseOrderList: [],
        },
        () => {
          // this.renderForm(isEdit, [], true, serviceTypeCat);
          this.renderForm(
            isEdit,
            [],
            undefined,
            [],
            validateNewCatTransportModes ? newCatTransportModes : undefined,
            newcatSentby,
            InitnewCatDLOKAM,
            [],
          );
        },
      );
    } else {
      let { info } = this.state;
      info[id] = null;
      info["osLis"] = [];
      info["Agente"] = undefined;
      info["ShipmentsType"] = undefined;
      info["ServiceType"] = undefined;
      info["Borders"] = undefined;
      info["SistemaEp"] = sistemaDefault;
      info["FreightTermCode"] = undefined;
      info["TrasportMode"] = undefined;
      info["OKAM"] = undefined;
      info["DL"] = undefined;
      info["ServiceLevel"] = undefined;

      for (let i = 0; i < newTemplateForms[0].create.length; i++) {
        const e = newTemplateForms[0].create[i];
        if (e.id === "FreightTermCode") {
          newTemplateForms[0].create[i].selectCatalogName = "Freight";
        }
      }
      this.setState(
        {
          TemplateForms: newTemplateForms,
          buttonCheckValidateActive: true,
          info,
          posList: [],
          addConsolPlan: [],
          posPO: [],
          posPOClone: [],
          posPOcopy: [],
          poPurchaseOrderADD: [],
          poPurchaseOrderList: [],
        },
        () => {
          // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat);
          this.renderForm(
            isEdit,
            undefined,
            true,
            [],
            [],
            [],
            InitnewCatDLOKAM,
            [],
          );
        },
      );
    }
    document.getElementById("loader0").style.display = "block";
    document.getElementById("loader1").style.display = "block";

    document.getElementById("loaderActive").style.display = "none";
  };

  handleChangeSelect = async (evt, data, id) => {
    let { info, catalgoSearch, isEdit, TemplateForms, customerEdit } =
      this.state;

    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let newTemplateForms = _.cloneDeep(TemplateForms);
    let serviceTypeCat = [];
    let InitnewCatDLOKAM = [];
    let initNewCatServiceLevel = [];

    let transportModeSelected = undefined;
    let catalogoTrasportModeFinal = undefined;
    let newcatSentbyFinal = undefined;

    if (id === "TrasportMode") {
      transportModeSelected = data ? data.key : undefined;
    } else {
      transportModeSelected = info["TrasportMode"]
        ? info["TrasportMode"].key
        : undefined;
    }
    if (info.NameCustomers && info.NameCustomers.OwnerTeam) {
      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        info.NameCustomers.OwnerTeam,
        transportModeSelected,
      );
      InitnewCatDLOKAM = newCatDLOKAM;
      catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;
      newcatSentbyFinal = newcatSentby;
    } else {
      catalogoTrasportModeFinal = [];
    }

    if (data) {
      let validateCatST = data.text;
      info[id] = data;
      if (id === "TrasportMode") {
        info["ShipmentsType"] = undefined;
        info["ServiceType"] = undefined;
        info["Borders"] = undefined;
        info["Agente"] = undefined;
        info["FreightTermCode"] = undefined;
        info["DL"] = undefined;
        info["OKAM"] = undefined;
        info["ServiceLevel"] = undefined;

        info["SistemaEp"] = info["SistemaEp"] = newcatSentbyFinal.filter(
          (e) => e.key === 1 || e.key === 2,
        )[0];
        // info["DL"] = undefined;
        // info["OKAM"] = undefined;
        if (data.key === 3) {
          for (
            let i = 0;
            i <
            newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"]
              .length;
            i++
          ) {
            const e =
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ][i];
            if (e.id === "SistemaEp") {
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ][i].hidden = false;
            }
            if (e.id === "Borders" || e.id === "Agente") {
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ][i].view = false;
            }
            // if (e.id === 'OKAM'){
            //   newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit" ][i].view=true;

            // }
            // if (e.id === 'DL'){
            //   newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit" ][i].view=true;

            // }
          }
        } else {
          for (
            let i = 0;
            i <
            newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"]
              .length;
            i++
          ) {
            const e =
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ][i];
            if (e.id === "SistemaEp") {
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ][i].hidden = true;
            }
            if (e.id === "Borders" || e.id === "Agente") {
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ][i].view = false;
            }
            // if (e.id === 'OKAM'){
            //   newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit" ][i].view=false;
            // }
            // if (e.id === 'DL'){
            //   newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit" ][i].view=false;
            // }
          }
        }
        for (
          let i = 0;
          i <
          newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"]
            .length;
          i++
        ) {
          const e =
            newTemplateForms[0][
              customerEdit === true ? "editCustomer" : "edit"
            ][i];
          if (e.id === "FreightTermCode") {
            newTemplateForms[0][
              customerEdit === true ? "editCustomer" : "edit"
            ][i].selectCatalogName = TRANSPORT_MODE_CATALOG_OPTION[data.key];
          }
        }

        serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
          (e) =>
            e[validateCatST] === "1" && e.SystemId === info["SistemaEp"].key,
        );

        this.setState(
          {
            info,
            TemplateForms: newTemplateForms,
            buttonCheckValidateActive: true,
          },
          () => {
            // this.renderForm(isEdit, [], undefined, serviceTypeCat);
            this.renderForm(
              isEdit,
              [],
              undefined,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            );
          },
        );
      } else {
        if (id === "ShipmentsType") {
          info["ServiceLevel"] = undefined;
          let catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          let uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );

          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );

          initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.ServiceTypeId === info["ServiceType"].key &&
              e.CatShipmentTypeId === info["ShipmentsType"].key,
          );

          this.setState({ info, buttonCheckValidateActive: true }, () =>
            // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat)
            this.renderForm(
              isEdit,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            ),
          );
        } else if (id === "ServiceType") {
          info["ShipmentsType"] = undefined;
          info["Borders"] = undefined;
          info["Agente"] = undefined;
          info["ServiceLevel"] = undefined;

          if (
            info["TrasportMode"].key === 3 &&
            (data.key === 3 || data.key === 2)
          ) {
            for (
              let i = 0;
              i <
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ].length;
              i++
            ) {
              const e =
                newTemplateForms[0][
                  customerEdit === true ? "editCustomer" : "edit"
                ][i];
              if (e.id === "Borders" || e.id === "Agente") {
                newTemplateForms[0][
                  customerEdit === true ? "editCustomer" : "edit"
                ][i].view = true;
              }
            }
          } else {
            for (
              let i = 0;
              i <
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ].length;
              i++
            ) {
              const e =
                newTemplateForms[0][
                  customerEdit === true ? "editCustomer" : "edit"
                ][i];
              if (e.id === "Borders" || e.id === "Agente") {
                newTemplateForms[0][
                  customerEdit === true ? "editCustomer" : "edit"
                ][i].view = false;
              }
            }
          }

          let catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          let uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );

          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );

          this.setState(
            {
              info,
              TemplateForms: newTemplateForms,
              buttonCheckValidateActive: true,
            },
            () => {
              // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat);
              this.renderForm(
                isEdit,
                uniqueCatalog,
                true,
                serviceTypeCat,
                catalogoTrasportModeFinal,
                newcatSentbyFinal,
                InitnewCatDLOKAM,
                [],
              );
            },
          );
        } else if (id === "SistemaEp") {
          info["ShipmentsType"] = undefined;
          info["ServiceType"] = undefined;
          info["ServiceLevel"] = undefined;
          // info["SistemaEp"] = sistemaDefault;
          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );
          this.setState({ info, buttonCheckValidateActive: true }, () => {
            // this.renderForm(isEdit, [], undefined, serviceTypeCat);
            this.renderForm(
              isEdit,
              [],
              undefined,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              [],
            );
          });
        } else {
          let catalogNuevo = [];
          let uniqueCatalog = [];
          if (
            info["TrasportMode"] !== undefined &&
            info["ServiceType"] !== undefined
          ) {
            catalogNuevo = catalgoSearch[0]["ServiceTypeList"].filter(
              (e) =>
                e.TransportModeId === info["TrasportMode"].key &&
                e.SystemId === info["SistemaEp"].key &&
                e.ServiceTypeId === info["ServiceType"].key,
            );
            uniqueCatalog = Array.from(
              new Map(catalogNuevo.map((item) => [item.key, item])).values(),
            );
          }
          if (info["TrasportMode"] && info["TrasportMode"].text) {
            serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
              (e) =>
                e[info["TrasportMode"].text] === "1" &&
                e.SystemId === info["SistemaEp"].key,
            );
          } else {
            serviceTypeCat = [];
          }

          if (info["ShipmentsType"] && info["ShipmentsType"].key) {
            initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
              (e) =>
                e.TransportModeId === info["TrasportMode"].key &&
                e.ServiceTypeId === info["ServiceType"].key &&
                e.CatShipmentTypeId === info["ShipmentsType"].key,
            );
          }

          this.setState({ info, buttonCheckValidateActive: true }, () =>
            // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat)
            this.renderForm(
              isEdit,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            ),
          );
        }
      }
    } else {
      info[id] = "";
      if (id === "TrasportMode") {
        let catalogNuevo = [];
        let initNewCatServiceLevel = [];
        for (
          let i = 0;
          i <
          newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"]
            .length;
          i++
        ) {
          const e =
            newTemplateForms[0][
              customerEdit === true ? "editCustomer" : "edit"
            ][i];
          if (e.id === "SistemaEp") {
            newTemplateForms[0][
              customerEdit === true ? "editCustomer" : "edit"
            ][i].hidden = true;
          }
          if (e.id === "Borders" || e.id === "Agente") {
            newTemplateForms[0][
              customerEdit === true ? "editCustomer" : "edit"
            ][i].view = false;
          }
        }

        info["ShipmentsType"] = undefined;
        info["ServiceType"] = undefined;
        info["Borders"] = undefined;
        info["Agente"] = undefined;
        info["SistemaEp"] = sistemaDefault;
        info["FreightTermCode"] = undefined;
        info["DL"] = undefined;
        info["OKAM"] = undefined;
        info["ServiceLevel"] = undefined;

        for (
          let i = 0;
          i <
          newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"]
            .length;
          i++
        ) {
          const e =
            newTemplateForms[0][
              customerEdit === true ? "editCustomer" : "edit"
            ][i];
          if (e.id === "FreightTermCode") {
            newTemplateForms[0][
              customerEdit === true ? "editCustomer" : "edit"
            ][i].selectCatalogName = "Freight";
          }
        }

        this.setState(
          {
            info,
            TemplateForms: newTemplateForms,
            buttonCheckValidateActive: true,
          },
          () => {
            // this.renderForm(isEdit, catalogNuevo);
            this.renderForm(
              isEdit,
              catalogNuevo,
              undefined,
              [],
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            );
          },
        );
      } else {
        if (id === "ShipmentsType") {
          info["ServiceLevel"] = undefined;
          let catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          let uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );

          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );

          this.setState({ info, buttonCheckValidateActive: true }, () =>
            // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat)
            this.renderForm(
              isEdit,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            ),
          );
        } else if (id === "ServiceType") {
          info["ShipmentsType"] = undefined;
          info["Borders"] = undefined;
          info["Agente"] = undefined;
          info["ServiceLevel"] = undefined;
          for (
            let i = 0;
            i <
            newTemplateForms[0][customerEdit === true ? "editCustomer" : "edit"]
              .length;
            i++
          ) {
            const e =
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ][i];
            if (e.id === "Borders" || e.id === "Agente") {
              newTemplateForms[0][
                customerEdit === true ? "editCustomer" : "edit"
              ][i].view = false;
            }
          }

          let catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          let uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );

          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );

          this.setState(
            {
              info,
              TemplateForms: newTemplateForms,
              buttonCheckValidateActive: true,
            },
            () =>
              // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat)
              this.renderForm(
                isEdit,
                uniqueCatalog,
                true,
                serviceTypeCat,
                catalogoTrasportModeFinal,
                newcatSentbyFinal,
                InitnewCatDLOKAM,
                initNewCatServiceLevel,
              ),
          );
        } else {
          let catalogNuevo = [];
          let uniqueCatalog = [];
          let initNewCatServiceLevel = [];

          if (
            info["TrasportMode"] !== undefined &&
            info["ServiceType"] !== undefined
          ) {
            catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
              (e) =>
                e.TransportModeId === info["TrasportMode"].key &&
                e.SystemId === info["SistemaEp"].key &&
                e.ServiceTypeId === info["ServiceType"].key,
            );

            uniqueCatalog = Array.from(
              new Map(catalogNuevo.map((item) => [item.key, item])).values(),
            );
          }
          if (info["TrasportMode"] && info["TrasportMode"].text) {
            serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
              (e) =>
                e[info["TrasportMode"].text] === "1" &&
                e.SystemId === info["SistemaEp"].key,
            );
          } else {
            serviceTypeCat = [];
          }

          if (info["ShipmentsType"] && info["ShipmentsType"].key) {
            initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
              (e) =>
                e.TransportModeId === info["TrasportMode"].key && // Corregido el error tipográfico
                e.ServiceTypeId === info["ServiceType"].key &&
                e.CatShipmentTypeId === info["ShipmentsType"].key,
            );
          }

          this.setState({ info, buttonCheckValidateActive: true }, () =>
            // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat)
            this.renderForm(
              isEdit,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            ),
          );
        }
      }
    }
  };

  getOrdersTo = async (IdCustomer, codeEP) => {
    let lang = this.props.lng;
    return new Promise(function (resolve, reject) {
      let data = {
        IdCustomer: IdCustomer,
        codeEP: codeEP,
        lang,
      };

      axios
        .post(`${Services.PLANTRANSPORT.path}plantrasp/getorder-to`, data)
        .then((response) => {
          let posList = response.data.data;
          let posPO = response.data.dataPo;
          let posPOcopy = response.data.dataPo;
          let catAgente = response.data.catAgente;
          for (let i = 0; i < posList.length; i++) {
            const e = posList[i];
            e.hidden = false;
            e.Visible = 1;
            e.checked = false;
          }
          for (let i = 0; i < posPO.length; i++) {
            const e = posPO[i];
            e.hidden = false;
            e.key = e.POItemsId;
            e.Visible = 1;
            e.checked = false;
          }
          resolve({ posList, posPO, posPOcopy, catAgente });
        })
        .catch((error) => {
          console.warn(error);
        });
    });
  };

  handleChangeSearch = async (evt, data, id) => {
    let { info, catalgoSearch, isEdit } = this.state;
    let catalogNuevo = [];
    let serviceTypeCat = [];
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let newTemplateForms = _.cloneDeep(TemplateForms);
    let InitnewCatDLOKAM = [];
    document.getElementById("loader0").style.display = "none";
    document.getElementById("loader1").style.display = "none";
    document.getElementById("loaderActive").style.display = "block";

    // if (info["TrasportMode"]) {
    //   serviceTypeCat = catalgoSearch[0]["CatServiceTypes"].filter(
    //     (e) => e[info["TrasportMode"].text] === "1" && e.SystemId === info["SistemaEp"].key
    //   );
    // }

    if (data) {
      let IdCustomer = data.key;
      let codeEP = data.codeEp;
      info["Agente"] = undefined;
      info[""] = undefined;
      info["ShipmentsType"] = undefined;
      info["ServiceType"] = undefined;
      info["Borders"] = undefined;
      info["SistemaEp"] = sistemaDefault;
      info["FreightTermCode"] = undefined;
      info["TrasportMode"] = undefined;
      info["OKAM"] = undefined;
      info["DL"] = undefined;
      info["ServiceLevel"] = undefined;

      for (let i = 0; i < newTemplateForms[0].create.length; i++) {
        const e = newTemplateForms[0].create[i];
        if (e.id === "FreightTermCode") {
          newTemplateForms[0].create[i].selectCatalogName = "Freight";
        }
      }

      info[id] = data;
      let { posList, posPO, catAgente, posPOcopy } = await this.getOrdersTo(
        IdCustomer,
        codeEP,
      );
      catalgoSearch[0].CatAgente = catAgente;
      info["osLis"] = [];
      info["poPurchaselist"] = [];
      let newCatTransportModes = [];
      let validateNewCatTransportModes = false;
      let newcatSentby = undefined;

      if (data.OwnerTeam === null) {
        validateNewCatTransportModes = true;
        newCatTransportModes = newcatalgoSearch[0]["CatTransportModes"] = [];
      } else {
        let validateOwner = await this.validateOwner(data.OwnerTeam);
        validateNewCatTransportModes =
          validateOwner.validateNewCatTransportModes;
        newCatTransportModes = validateOwner.newCatTransportModes;
        newcatSentby = validateOwner.newcatSentby;
        InitnewCatDLOKAM = validateOwner.newCatDLOKAM;
      }

      this.setState(
        {
          TemplateForms: newTemplateForms,
          buttonCheckValidateActive: true,
          info,
          posList,
          posPO,
          posPOcopy,
          posPOClone: _.cloneDeep(posPO),
          addConsolPlan: [],
          poPurchaseOrderADD: [],
          poPurchaseOrderList: [],
        },
        () => {
          // this.renderForm(isEdit, [], true, serviceTypeCat);
          this.renderForm(
            isEdit,
            [],
            undefined,
            [],
            validateNewCatTransportModes ? newCatTransportModes : undefined,
            newcatSentby,
            InitnewCatDLOKAM,
            [],
          );
        },
      );
    } else {
      let { info } = this.state;
      info[id] = null;
      info["osLis"] = [];
      info["Agente"] = undefined;
      info["ShipmentsType"] = undefined;
      info["ServiceType"] = undefined;
      info["Borders"] = undefined;
      info["SistemaEp"] = sistemaDefault;
      info["FreightTermCode"] = undefined;
      info["TrasportMode"] = undefined;
      info["OKAM"] = undefined;
      info["DL"] = undefined;
      info["ServiceLevel"] = undefined;

      for (let i = 0; i < newTemplateForms[0].create.length; i++) {
        const e = newTemplateForms[0].create[i];
        if (e.id === "FreightTermCode") {
          newTemplateForms[0].create[i].selectCatalogName = "Freight";
        }
      }
      this.setState(
        {
          TemplateForms: newTemplateForms,
          buttonCheckValidateActive: true,
          info,
          posList: [],
          addConsolPlan: [],
          posPO: [],
          posPOClone: [],
          posPOcopy: [],
          poPurchaseOrderADD: [],
          poPurchaseOrderList: [],
        },
        () => {
          // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat);
          this.renderForm(
            isEdit,
            undefined,
            true,
            [],
            [],
            [],
            InitnewCatDLOKAM,
            [],
          );
        },
      );
    }
    document.getElementById("loader0").style.display = "block";
    document.getElementById("loader1").style.display = "block";

    document.getElementById("loaderActive").style.display = "none";
  };
  /*
    ####################################GENERACION DE CAMPOS####################################
   */
  panelChange = (id) => (evt, expanded) => {
    let { createFormsData } = this.state;
    createFormsData.map((form) => {
      if (form.id == id) {
        form.expanded = expanded;
      }
    });
    this.setState({ createFormsData });
  };

  onSelectLeft = (selectedRowKeys, selectedRows) => {
    this.setState({
      leftSelectedKeys: selectedRowKeys,
      leftSelectedRows: selectedRows,
    });
  };

  onSelectRight = (selectedRowKeys, selectedRows) => {
    this.setState({
      rightSelectedKeys: selectedRowKeys,
      rightSelectedRows: selectedRows,
    });
  };

  addPOPurchaseOrdeAvaiable = () => {
    const { leftSelectedRows, leftSelectedKeys, posPO, poPurchaseOrderADD } =
      this.state;

    if (!leftSelectedKeys.length) return;

    const newLeft = posPO.filter(
      (item) => !leftSelectedKeys.includes(item.POItemsId),
    );

    const newRight = [...poPurchaseOrderADD, ...leftSelectedRows];

    this.setState({
      posPO: newLeft,
      poPurchaseOrderADD: newRight,
      leftSelectedKeys: [],
      leftSelectedRows: [],
      leftSearch: "",
    });
  };

  removePOPurchaseOrdeAvaiable = () => {
    const { rightSelectedRows, rightSelectedKeys, posPO, poPurchaseOrderADD } =
      this.state;

    if (!rightSelectedKeys.length) return;

    const newRight = poPurchaseOrderADD.filter(
      (item) => !rightSelectedKeys.includes(item.POItemsId),
    );

    const newLeft = [...posPO, ...rightSelectedRows];

    this.setState({
      posPO: newLeft,
      poPurchaseOrderADD: newRight,
      rightSelectedKeys: [],
      rightSelectedRows: [],
      rightSearch: "",
    });
  };

  addVisibility = () => {
    const { leftSelectedKeys, leftSelectedRows, posList, addConsolPlan } =
      this.state;

    if (!leftSelectedKeys.length) return;

    const newLeft = posList.filter(
      (item) => !leftSelectedKeys.includes(item.ServiceOrderId),
    );

    const newRight = [...addConsolPlan, ...leftSelectedRows];

    this.setState({
      posList: newLeft,
      addConsolPlan: newRight,
      leftSelectedKeys: [],
      leftSelectedRows: [],
      leftSearch: "",
    });
  };

  removeVisibility = () => {
    const { rightSelectedKeys, rightSelectedRows, posList, addConsolPlan } =
      this.state;

    if (!rightSelectedKeys.length) return;

    const newRight = addConsolPlan.filter(
      (item) => !rightSelectedKeys.includes(item.ServiceOrderId),
    );

    const newLeft = [...posList, ...rightSelectedRows];

    this.setState({
      posList: newLeft,
      addConsolPlan: newRight,
      rightSelectedKeys: [],
      rightSelectedRows: [],
      rightSearch: "",
    });
  };

  //save purchase order list

  handleSavePurchase = async () => {
    let { catalgoSearch, info, poPurchaseOrderADD, isEdit } = this.state;

    let newcatalgoSearch = _.cloneDeep(catalgoSearch);

    //console.log("info", info);
    if (info["NameCustomers"] === undefined || info["NameCustomers"] === null) {
      this.cancelModal();
    } else {
      info["poPurchaselist"] = [...poPurchaseOrderADD];
      info.lineCarge = poPurchaseOrderADD.length;
      info.totalweights = 0;
      info.QTYConfirmated = 0;
      let InitnewCatDLOKAM = [];
      let initNewCatServiceLevel = [];
      let transportModeSelected = info["TrasportMode"]
        ? info["TrasportMode"].key
        : undefined;
      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        info.NameCustomers.OwnerTeam,
        transportModeSelected,
      );
      InitnewCatDLOKAM = newCatDLOKAM;
      let catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;

      poPurchaseOrderADD.forEach((e, index) => {
        info.QTYConfirmated = info.QTYConfirmated + Number(e.QTYOrdered);
        info.totalweights = info.totalweights + Number(e.GrossWeight);
      });
      let catalogNuevo = [];
      let serviceTypeCat = [];
      let uniqueCatalog = [];

      if (info["TrasportMode"]) {
        if (
          info["TrasportMode"] !== undefined &&
          info["ServiceType"] !== undefined
        ) {
          catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );
        }

        if (info["ShipmentsType"] && info["ShipmentsType"].key) {
          initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key && // Corregido el error tipográfico
              e.ServiceTypeId === info["ServiceType"].key &&
              e.CatShipmentTypeId === info["ShipmentsType"].key,
          );
        }

        serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
          (e) =>
            e[info["TrasportMode"].text] === "1" &&
            e.SystemId === info["SistemaEp"].key,
        );

        this.setState(
          {
            info,
            visible: false,
            rightSelectedKeys: [],
            leftSelectedKeys: [],
          },
          () => {
            openNotification("success", this.props.t("correctly_updated"));
            this.renderForm(
              isEdit,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentby,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            );
          },
        );
      } else {
        if (
          typeof info["NameCustomers"] !== "undefined" &&
          typeof info["NameCustomers"] === "object"
        ) {
          //console.log("info if 2", info);

          let {
            validateNewCatTransportModes,
            newCatTransportModes,
            newcatSentby,
            newCatDLOKAM,
          } = await this.validateOwner(
            info.NameCustomers.OwnerTeam,
            transportModeSelected,
          );
          InitnewCatDLOKAM = newCatDLOKAM;
          let catalogoTrasportModeFinal = validateNewCatTransportModes
            ? newCatTransportModes
            : undefined;
          this.setState(
            {
              info,
              visible: false,
            },
            () => {
              openNotification("success", this.props.t("correctly_updated"));
              this.renderForm(
                isEdit,
                [],
                undefined,
                [],
                catalogoTrasportModeFinal,
                newcatSentby,
                InitnewCatDLOKAM,
                initNewCatServiceLevel,
              );
            },
          );
        } else {
          this.setState(
            {
              rightSelectedKeys: [],
              leftSelectedKeys: [],
              info,
              visible: false,
            },
            () => {
              openNotification("success", this.props.t("correctly_updated"));
              this.renderForm(
                isEdit,
                catalogNuevo,
                true,
                serviceTypeCat,
                [],
                [],
                [],
                InitnewCatDLOKAM,
                [],
              );
            },
          );
        }
      }
    }
  };

  renderForm = (
    isEdit,
    catalogNuevo,
    flat,
    serviceTypeCat,
    newCatTransportModes,
    newcatSentby,
    InitnewCatDLOKAM,
    initNewCatServiceLevel,
  ) => {
    let {
      TemplateForms,
      info,
      columns_OS,
      showCatalogModal,
      viewpass,
      preview,
      createFormsData,
      errorPass,
      catalgoSearch,
      value,
      statusId,
      customerEdit,
      poActive,
      columns_PurchaceOrder,
    } = this.state;

    createFormsData = [];
    const { classes } = this.props;

    TemplateForms.map((TemplateForm) => {
      createFormsData.push({
        img: TemplateForm.img,
        id: TemplateForm.id,
        expanded: true,
        titulo: TemplateForm.titulo,
        form: TemplateForm[
          isEdit
            ? customerEdit === true
              ? "editCustomer"
              : "edit"
            : "previewForm"
        ].map((e) => {
          if (e.type === "Input") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label>
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Input
                    required
                    onFocus={(e) => {
                      e.target.setAttribute("autocomplete", "none");
                    }}
                    type={e.datatype}
                    placeholder={this.props.t(e.placeHolder)}
                    name={e.id}
                    value={info[e.id]}
                    disabled={e.disabled}
                    // maxlength={e.maxlength}
                    // minlength={e.minlength}
                    className={e.id === "Email" ? "email-lower" : ""}
                    autoComplete="new-password"
                    onChange={this.handleChange(e.id, isEdit ? true : false)}
                    max={e.max}
                  />
                </div>
              </div>
            );
          }
          if (e.type === "Label") {
            if (e.id === "TransportOrderNo") {
              if (statusId === 3) {
                let labelTranportOrder = "";
                if (e.check) {
                  labelTranportOrder = e.selectCatalogName[0].label;
                } else if (typeof info[e.id] === "object") {
                  labelTranportOrder =
                    info[e.id] === null ? "" : this.props.t(info[e.id].text);
                } else if (e.separador) {
                  labelTranportOrder = Number(info[e.id]).toLocaleString(
                    "en-US",
                  );
                } else {
                  labelTranportOrder = this.props.t(info[e.id]);
                }

                return (
                  <div
                    style={{ marginTop: "15px" }}
                    className={e.class}
                    key={e.id}
                  >
                    <Fade left opposite>
                      {" "}
                      <span id={e.id} style={e.style}>
                        <label
                          style={{
                            color: "#000a2e",
                            marginBottom: "1em",
                            fontWeight: "bold",
                          }}
                        >
                          {this.props.t(e.label)}
                        </label>
                      </span>
                    </Fade>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "2em",
                      }}
                    >
                      {labelTranportOrder.length > 22 ? (
                        <Popover
                          content={
                            <div style={{ width: 182, maxHeight: 282 }}>
                              {labelTranportOrder}
                            </div>
                          }
                        >
                          {labelTranportOrder
                            ? `${labelTranportOrder.substring(0, 22)}${
                                labelTranportOrder.length > 15 ? "..." : ""
                              }`
                            : ""}
                        </Popover>
                      ) : (
                        <span id={e.id} style={e.style}>
                          <label style={{ color: "", fontWeight: "100" }}>
                            {labelTranportOrder}
                          </label>
                        </span>
                      )}
                    </div>
                  </div>
                );
              }
            } else {
              if (e.view) {
                return (
                  <div
                    style={{ marginTop: "15px" }}
                    className={e.class}
                    key={e.id}
                  >
                    <Fade left opposite>
                      {" "}
                      <span id={e.id} style={e.style}>
                        <label
                          style={{
                            color: "#000a2e",
                            marginBottom: "1em",
                            fontWeight: "bold",
                          }}
                        >
                          {this.props.t(e.label)}
                        </label>
                      </span>
                    </Fade>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "2em",
                      }}
                    >
                      <span id={e.id} style={e.style}>
                        <label style={{ color: "", fontWeight: "100" }}>
                          {this.props.t(
                            e.check
                              ? e.selectCatalogName[info[e.id] - 1].label
                              : typeof info[e.id] === "object"
                                ? info[e.id] === null
                                  ? ""
                                  : info[e.id].text
                                : e.separador
                                  ? e.format === "weight" || e.format === "dimension"
                                    ? formatMeasurement(info[e.id], e.format)
                                    : Number(info[e.id]).toLocaleString("En-us")
                                  : info[e.id],
                          )}
                        </label>
                      </span>
                    </div>
                  </div>
                );
              }
            }
          } else if (e.type === "SelectSearch") {
            let autocompleteValue = info[e.id];
            return (
              <div
                style={{
                  marginTop: "15px",
                }}
                className={e.class}
                key={e.id}
              >
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label
                      style={{
                        marginBottom: "15px",
                        color: e.error && e.error != "" ? "#f00" : "#000a2e",
                        fontWeight: "bold",
                      }}
                    >
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ alignItems: "center" }}>
                  <Autocomplete
                    noOptionsText={this.props.t("no_options")}
                    closeText={false}
                    openText={false}
                    style={{ marginTop: "6px" }}
                    id="size-small-standard"
                    className="input-euro"
                    size="small"
                    // freeSolo
                    ListboxProps={{
                      sx: { fontSize: 12 },
                    }}
                    sx={{
                      "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                        fontSize: 12,
                      },
                    }}
                    options={
                      catalgoSearch[0][e.selectCatalogName]
                        ? catalgoSearch[0][e.selectCatalogName]
                        : []
                    }
                    getOptionLabel={(option) => option.text}
                    renderOption={(props, option, value) => {
                      props.key = option.key;
                      return (
                        <div {...props}>
                          {option.subText && option.subText != "" ? (
                            <div className="row">
                              <div className="col-12">{option.text}</div>

                              <div className="col-12">
                                <label style={{ opacity: ".5" }}>
                                  {option.subText}
                                </label>{" "}
                              </div>
                            </div>
                          ) : (
                            <span>{option.text}</span>
                          )}
                        </div>
                      );
                    }}
                    filterOptions={(options, event) => {
                      let filteredOptions = options.filter((opt) => {
                        return (
                          event.inputValue == "" ||
                          opt.text
                            .toLowerCase()
                            .includes(event.inputValue.toLowerCase())
                        );
                      });
                      return filteredOptions;
                    }}
                    onChange={(evt, data) => {
                      this.handleChangeSearch(evt, data, e.id);
                    }}
                    classes={
                      e.id == "CustomerId"
                        ? {
                            clearIndicatorDirty: classes.clearIndicator,
                            popupIndicator: classes.popupIndicator,
                            popupIndicatorOpen: classes.popupIndicatorOpen,
                          }
                        : false
                    }
                    isOptionEqualToValue={(option, value) => {
                      return option.value == value.value;
                    }}
                    value={autocompleteValue}
                    renderInput={(params) => {
                      params.inputProps.value =
                        autocompleteValue && autocompleteValue.text
                          ? autocompleteValue.text
                          : params.inputProps.value;
                      return (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.textfield}
                        />
                      );
                    }}
                  />
                </div>
              </div>
            );
          } else if (e.type === "TextArea") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label
                      style={{
                        color: "#000a2e",
                        fontWeight: "bold",
                      }}
                    >
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextArea
                    required={e.required}
                    onFocus={(e) => {
                      e.target.setAttribute("autocomplete", "none");
                    }}
                    rows="4"
                    type={e.datatype}
                    placeholder={this.props.t(e.placeHolder)}
                    name={e.id}
                    value={info[e.id]}
                    className="custom-textarea"
                    style={{
                      width: "100%",
                      color: "#323C47",
                      fontSize: "12px",
                    }}
                    onChange={this.handleChange(e.id, isEdit ? true : false)}
                  />
                </div>
              </div>
            );
          } else if (e.type === "LabelRef") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label>
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Label value={info[e.id]} />
                </div>
              </div>
            );
          } else if (e.type === "CheckboxCicule") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label
                      style={{
                        color: "#000a2e",
                        fontWeight: "bold",
                        marginBottom: "1em",
                      }}
                    >
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div className="row" style={{ alignItems: "center" }}>
                  {e.selectCatalogName.map((w, index) => {
                    return (
                      <div
                        className="col-md-4"
                        style={{ alignItems: "center" }}
                      >
                        <Checkbox
                          radio
                          disabled={w.disabled}
                          style={{ color: "#000a2e" }}
                          label={
                            <label>
                              <span className="labelBody">
                                {this.props.t(w.label)}
                              </span>
                            </label>
                          }
                          name={"checkbox-23"}
                          checked={w.id === info[e.id] ? info[e.id] : false}
                          onChange={(e, data) => {
                            let info = this.state.info;
                            info["TypeOrder"] = w.id;
                            if (!poActive) {
                              info.lineCarge = info.poPurchaselist.length;
                              info.totalweights = 0;
                              info.QTYConfirmated = 0;
                              info.poPurchaselist.forEach((e, index) => {
                                info.QTYConfirmated =
                                  info.QTYConfirmated + Number(e.QTYOrdered);
                                info.totalweights =
                                  info.totalweights + Number(e.GrossWeight);
                              });
                            } else {
                              info.lineCarge = info.osLis.length;
                              info.totalweights = 0;
                              info.QTYConfirmated = 0;
                              info.osLis.forEach((e, index) => {
                                info.QTYConfirmated =
                                  info.QTYConfirmated + Number(e.QTYOrdered);
                                info.totalweights =
                                  info.totalweights + Number(e.GrossWeight);
                              });
                            }

                            let catalogNuevo = [];
                            let serviceTypeCat = [];
                            let uniqueCatalog = [];

                            if (info["TrasportMode"]) {
                              if (
                                info["TrasportMode"] !== undefined &&
                                info["ServiceType"] !== undefined
                              ) {
                                catalogNuevo = catalgoSearch[0][
                                  "ServiceTypeList"
                                ].filter(
                                  (e) =>
                                    e.TransportModeId ===
                                      info["TrasportMode"].key &&
                                    e.ServiceTypeId === info["ServiceType"].key,
                                );
                                uniqueCatalog = Array.from(
                                  new Map(
                                    catalogNuevo.map((item) => [
                                      item.key,
                                      item,
                                    ]),
                                  ).values(),
                                );
                              }
                              serviceTypeCat = catalgoSearch[0][
                                "CatServiceTypes"
                              ].filter(
                                (e) =>
                                  e[info["TrasportMode"].text] === "1" &&
                                  e.SystemId === info["SistemaEp"].key,
                              );
                            }

                            this.setState(
                              {
                                info,
                                value: w.id,
                                poActive: !poActive,
                                buttonCheckValidateActive: true,
                              },
                              () =>
                                this.renderForm(
                                  isEdit,
                                  uniqueCatalog,
                                  true,
                                  serviceTypeCat,
                                  newCatTransportModes,
                                  newcatSentby,
                                  InitnewCatDLOKAM,
                                  initNewCatServiceLevel,
                                ),
                            );
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          } else if (e.type === "Bottom") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <div className="float-right">
                  <Button
                    color="primary"
                    className="d-flex align-items-center"
                    title={this.props.t("create_new")}
                    onClick={() => {
                      if (poActive) {
                        this.setState((prev) => ({
                          buttonCheckValidateActive: true,
                          visible: true,
                          initialLeftData: [...prev.posPO],
                          initialRightData: [...prev.poPurchaseOrderADD],
                        }));
                      } else {
                        this.setState((prev) => ({
                          buttonCheckValidateActive: true,
                          visible: true,
                          initialLeftData: [...prev.posList],
                          initialRightData: [...prev.addConsolPlan],
                        }));
                      }
                    }}
                  >
                    <span className="icon-plus icon-button-add" />
                    {this.props.t(e.labelBottom)}
                  </Button>
                </div>
              </div>
            );
          } else if (e.type === "Table") {
            return (
              <div className={e.class} key={e.id}>
                {poActive ? (
                  info.poPurchaselist.length > 0 ? (
                    <Tables
                      data={info.poPurchaselist ? info.poPurchaselist : []}
                      columns={columns_PurchaceOrder}
                      options={{}}
                    ></Tables>
                  ) : (
                    ""
                  )
                ) : info.osLis.length > 0 ? (
                  <Tables
                    data={info.osLis ? info.osLis : []}
                    columns={columns_OS}
                    options={{}}
                  ></Tables>
                ) : (
                  ""
                )}
              </div>
            );
          } else if (e.type === "Select") {
            // if (!e.hidden) {
            let valueShipmTyp = info[e.id];
            if (e.id === "ShipmentsType" && catalogNuevo && !flat) {
              valueShipmTyp = null;
            }
            if (e.view) {
              return (
                <div
                  style={{ marginTop: "15px" }}
                  className={e.class}
                  key={e.id}
                >
                  <Fade left opposite>
                    <span id={e.id} style={e.style}>
                      {" "}
                      <label
                        style={{
                          color: e.error && e.error != "" ? "#f00" : "#000a2e",
                          fontWeight: "bold",
                          marginBottom: "1em",
                        }}
                      >
                        {this.props.t(e.label)}
                        {e.required ? (
                          <span style={{ color: "#ff0000" }}>*</span>
                        ) : (
                          ""
                        )}{" "}
                      </label>
                    </span>
                  </Fade>
                  <Autocomplete
                    closeText={false}
                    openText={false}
                    disableClearable={
                      e.disableClearable ? e.disableClearable : false
                    }
                    id={e.id2}
                    ListboxProps={{
                      sx: { fontSize: 12 },
                    }}
                    noOptionsText={
                      e.id === "OKAM" || e.id === "DL"
                        ? ""
                        : this.props.t("no_options")
                    }
                    sx={{
                      "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                        fontSize: 12,
                      },
                    }}
                    disabled={
                      e.hidden
                        ? e.hidden
                        : e.id === "SistemaEp"
                          ? newcatSentby.length === 1
                            ? true
                            : false
                          : false
                    }
                    filterOptions={(options, event) => {
                      let filteredOptions = options.filter((opt) => {
                        return (
                          event.inputValue == "" ||
                          opt.title
                            .toLowerCase()
                            .includes(event.inputValue.toLowerCase())
                        );
                      });
                      if (e.id === "OKAM" || e.id === "DL") {
                        if (event.inputValue.length > 2) {
                          return filteredOptions;
                        } else {
                          return [];
                        }
                      } else {
                        return filteredOptions;
                      }
                    }}
                    options={
                      e.id === "ShipmentsType" && catalogNuevo
                        ? catalogNuevo
                        : (e.id === "ShipmentsType" ||
                              e.id === "ServiceType") &&
                            (!info["TrasportMode"] ||
                              info["TrasportMode"] === "")
                          ? []
                          : e.id === "ServiceType" && serviceTypeCat
                            ? serviceTypeCat
                            : e.id === "TrasportMode" && newCatTransportModes
                              ? newCatTransportModes
                              : e.id === "SistemaEp" && newcatSentby
                                ? newcatSentby
                                : e.id === "DL" || e.id === "OKAM"
                                  ? InitnewCatDLOKAM
                                    ? InitnewCatDLOKAM
                                    : []
                                  : e.id === "ServiceLevel" &&
                                      initNewCatServiceLevel
                                    ? initNewCatServiceLevel
                                    : catalgoSearch[0][e.selectCatalogName]
                    }
                    getOptionLabel={(option) => option.title}
                    onChange={(evt, data) => {
                      this.handleChangeSelect(evt, data, e.id);
                    }}
                    value={valueShipmTyp ? valueShipmTyp : null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        className={classes.textfield}
                      />
                    )}
                  />
                </div>
              );
            }
          } else {
            return (
              <div
                className={e.class}
                style={{ marginTop: "20px" }}
                key={e.id}
              ></div>
            );
          }
        }),
      });
    });
    this.setState({
      createFormsData,
      showCatalogModal,
      info,
    });
  };

  handleSave = async () => {
    let { addConsolPlan, catalgoSearch, info, isEdit } = this.state;
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    if (info["NameCustomers"] === undefined || info["NameCustomers"] === null) {
      this.cancelModal();
    } else {
      info.osLis = [...addConsolPlan];
      let InitnewCatDLOKAM = [];
      let initNewCatServiceLevel = [];

      info.lineCarge = addConsolPlan.length;
      info.totalweights = 0;
      info.QTYConfirmated = 0;

      addConsolPlan.forEach((e, index) => {
        info.QTYConfirmated = info.QTYConfirmated + Number(e.QTYOrdered);
        info.totalweights = info.totalweights + Number(e.GrossWeight);
      });

      let transportModeSelected = info["TrasportMode"]
        ? info["TrasportMode"].key
        : undefined;
      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        info.NameCustomers.OwnerTeam,
        transportModeSelected,
      );
      InitnewCatDLOKAM = newCatDLOKAM;
      let catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;

      let catalogNuevo = [];
      let serviceTypeCat = [];
      let uniqueCatalog = [];

      if (info["TrasportMode"]) {
        if (
          info["TrasportMode"] !== undefined &&
          info["ServiceType"] !== undefined
        ) {
          catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );
        }

        serviceTypeCat = catalgoSearch[0]["CatServiceTypes"].filter(
          (e) =>
            e[info["TrasportMode"].text] === "1" &&
            e.SystemId === info["SistemaEp"].key,
        );

        if (info["ShipmentsType"] && info["ShipmentsType"].key) {
          initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.ServiceTypeId === info["ServiceType"].key &&
              e.CatShipmentTypeId === info["ShipmentsType"].key,
          );
        }

        this.setState(
          {
            info,
            visible: false,
          },
          () => {
            openNotification("success", this.props.t("correctly_updated"));
            this.renderForm(
              isEdit,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentby,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            );
          },
        );
      } else {
        if (
          typeof info["NameCustomers"] !== "undefined" &&
          typeof info["NameCustomers"] === "object"
        ) {
          //console.log("info if 2", info);

          let {
            validateNewCatTransportModes,
            newCatTransportModes,
            newcatSentby,
            newCatDLOKAM,
          } = await this.validateOwner(
            info.NameCustomers.OwnerTeam,
            transportModeSelected,
          );
          InitnewCatDLOKAM = newCatDLOKAM;
          let catalogoTrasportModeFinal = validateNewCatTransportModes
            ? newCatTransportModes
            : undefined;
          this.setState(
            {
              info,
              visible: false,
            },
            () => {
              openNotification("success", this.props.t("correctly_updated"));
              this.renderForm(
                isEdit,
                [],
                undefined,
                [],
                catalogoTrasportModeFinal,
                newcatSentby,
                InitnewCatDLOKAM,
                initNewCatServiceLevel,
              );
            },
          );
        } else {
          this.setState(
            {
              info,
              visible: false,
            },
            () => {
              openNotification("success", this.props.t("correctly_updated"));
              this.renderForm(
                isEdit,
                catalogNuevo,
                true,
                serviceTypeCat,
                [],
                [],
                InitnewCatDLOKAM,
                [],
              );
            },
          );
        }
      }
    }
  };

  cancelModal = () => {
    const { poActive, initialLeftData, initialRightData } = this.state;

    if (poActive) {
      this.setState({
        posPO: initialLeftData,
        poPurchaseOrderADD: initialRightData,
      });
    } else {
      this.setState({
        posList: initialLeftData,
        addConsolPlan: initialRightData,
      });
    }

    this.setState({
      leftSelectedKeys: [],
      leftSelectedRows: [],
      rightSelectedKeys: [],
      rightSelectedRows: [],
      visible: false,
      leftSearch: "",
      rightSearch: "",
    });
  };

  validateTransPlan = async (status) => {
    let { info, TemplateForms, catalgoSearch, isEdit } = this.state;

    let transportModeSelected = info["TrasportMode"]
      ? info["TrasportMode"].key
      : undefined;
    let catalogoTrasportModeFinal = undefined;
    let newcatSentbyFinal = undefined;
    let InitnewCatDLOKAM = [];
    let initNewCatServiceLevel = [];

    if (info.NameCustomers && info.NameCustomers.OwnerTeam) {
      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        info.NameCustomers.OwnerTeam,
        transportModeSelected,
      );
      InitnewCatDLOKAM = newCatDLOKAM;
      catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;
      newcatSentbyFinal = newcatSentby;
    } else {
      catalogoTrasportModeFinal = [];
    }

    let BODY = {
      headerDetails: info,
    };
    ValidationService.validate({
      target: "TRANSPLAN-CREATE",
      data: BODY,
      t: this.props.t,
    })
      .then(() => {
        TemplateForms[0].edit.map((e) => {
          e.style = { color: "#000000de" };
          e.error = "";
        });
        this.setState(
          { TemplateForms, buttonCheckValidateActive: false },
          () => {
            if (status !== 1) {
              if (info.TypeOrder === 2) {
                if (info.poPurchaselist.length > 0) {
                  this.saveInfoPt(status);
                } else {
                  var element = document.getElementById("inOrdenes");
                  element.style.color = "#ff0000";
                  element.scrollIntoView({
                    block: "center",
                    behavior: "smooth",
                  });
                  openNotification(
                    "error",
                    this.props.t("add_at_least_one_p_order"),
                  );
                  setTimeout(() => {
                    this.setState({ buttonCheckValidateActive: true });
                  }, 2500);
                }
              } else {
                if (info.osLis.length > 0) {
                  this.saveInfoPt(status);
                } else {
                  var element = document.getElementById("inOrdenes");
                  element.style.color = "#ff0000";
                  element.scrollIntoView({
                    block: "center",
                    behavior: "smooth",
                  });
                  openNotification(
                    "error",
                    this.props.t("add_at_least_one_s_order"),
                  );
                  setTimeout(() => {
                    this.setState({ buttonCheckValidateActive: true });
                  }, 2500);
                }
              }
            } else {
              this.saveInfoPt(status);
            }
          },
        );
      })
      .catch((errors) => {
        let Element = document.getElementById(Object.keys(errors)[0]);
        if (Element) {
          Element.scrollIntoView({ block: "end", behavior: "smooth" });
          Element.focus();
        }
        TemplateForms[0].edit.map((e, i) => {
          if (errors[e.id]) {
            e.style = { color: "#e57373" };
            e.error = errors[e.id].label;
          } else {
            e.error = "";
            e.style = { color: "#616161" };
          }
        });
        TemplateForms[0].editCustomer.map((e, i) => {
          if (errors[e.id]) {
            e.style = { color: "#e57373" };
            e.error = errors[e.id].label;
          } else {
            e.error = "";
            e.style = { color: "#616161" };
          }
        });
        this.setState(
          { TemplateForms, buttonCheckValidateActive: false },
          () => {
            openNotification(
              "error",
              this.props.t("add_all_mandatory_fields") + ".",
            );

            let catalogNuevo = [];
            let serviceTypeCat = [];
            let uniqueCatalog = [];

            if (info["TrasportMode"]) {
              if (
                info["TrasportMode"] !== undefined &&
                info["ServiceType"] !== undefined
              ) {
                catalogNuevo = catalgoSearch[0]["ServiceTypeList"].filter(
                  (e) =>
                    e.TransportModeId === info["TrasportMode"].key &&
                    e.ServiceTypeId === info["ServiceType"].key,
                );
                uniqueCatalog = Array.from(
                  new Map(
                    catalogNuevo.map((item) => [item.key, item]),
                  ).values(),
                );
              }
              serviceTypeCat = catalgoSearch[0]["CatServiceTypes"].filter(
                (e) =>
                  e[info["TrasportMode"].text] === "1" &&
                  e.SystemId === info["SistemaEp"].key,
              );
              if (info["ShipmentsType"] && info["ShipmentsType"].key) {
                initNewCatServiceLevel = catalgoSearch[0][
                  "ServiceLevel"
                ].filter(
                  (e) =>
                    e.TransportModeId === info["TrasportMode"].key &&
                    e.ServiceTypeId === info["ServiceType"].key &&
                    e.CatShipmentTypeId === info["ShipmentsType"].key,
                );
              }
            }
            // this.renderForm(isEdit, catalogNuevo, true, serviceTypeCat);
            this.renderForm(
              isEdit,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            );
          },
        );
      });
  };

  saveInfoPt = async (status) => {
    let { info } = this.state;

    let data = {
      TransportPlanId: info.TransportPlanId,
      statusId: status,
      FreightTermCode: info.FreightTermCode?.key,
      TransportModeId: info.TrasportMode.key,
      TypesServiceId: info.ServiceType.key,
      ShipmentTypeId: info.ShipmentsType.key,
      SystemId: info.SistemaEp.key,
      IncotermCode: info.Incoterm.key,
      CustomerId: info.NameCustomers.key,
      PlanningDate: "¿?",
      SpecialsInstructions: info.InstruccionesEspecificas,
      AdditionalsComments: info.Comentarios,
      // UserCreateId: 1,
      UserCreateId: info.UserCreateId,
      totalweights: info.totalweights,
      lineCarge: info.lineCarge,
      TypeOrder: info.TypeOrder,
      Oslist: info.osLis,
      poPurchaselist: info.poPurchaselist,
      DL: info.DL === undefined ? {} : info.DL,
      OKAM: info.OKAM === undefined ? {} : info.OKAM,
      ServiceLevel: info.ServiceLevel.key,
      Borders:
        info.Borders === undefined || info.Borders === ""
          ? null
          : info.Borders.key,
      Agente:
        info.Agente === undefined || info.Agente === "" ? {} : info.Agente,
    };
    this.props.updateInfoPt(data, status);
  };

  filterByFields = (item, search, fields) => {
    const text = search.toUpperCase();

    return fields.some((field) => {
      const value = item[field];

      if (!value) return false;

      return value.toString().toUpperCase().includes(text);
    });
  };

  render() {
    let {
      loadingInfo,
      isEdit,
      visible,
      statusId,
      poActive,
      leftSelectedKeys,
      poPurchaseOrderADD,
      rightSelectedKeys,
      posPO,
      columnAnt,
      createFormsData,
      buttonCheckValidateActive,
      posList,
      addConsolPlan,
      leftSearch,
      rightSearch,
      columns,
    } = this.state;

    const leftSource = poActive ? posPO : posList;
    const rightSource = poActive ? poPurchaseOrderADD : addConsolPlan;

    const fieldsToUse = poActive ? poFields : visibilityFields;

    const filteredLeftData = leftSource.filter((item) =>
      leftSearch ? this.filterByFields(item, leftSearch, fieldsToUse) : true,
    );

    const filteredRightData = rightSource.filter((item) =>
      rightSearch ? this.filterByFields(item, rightSearch, fieldsToUse) : true,
    );

    return loadingInfo ? (
      <Loader />
    ) : (
      <>
        {createFormsData
          ? createFormsData.map((form, index) => {
              return (
                <Card id={"loader" + index} className="myCard">
                  <ExpansionPanel
                    defaultExpanded
                    onChange={this.panelChange(form.id)}
                  >
                    <ExpansionPanelSummary
                      expandIcon={
                        form.expanded ? (
                          <ExpandLess style={{ marginRight: "1em" }} />
                        ) : (
                          <ExpandMore style={{ marginRight: "1em" }} />
                        )
                      }
                    >
                      {form.img ? (
                        <img
                          style={{ margin: "6px", marginTop: "-1px" }}
                          alt=""
                          src={form.img}
                          height="35"
                          width="35"
                        ></img>
                      ) : (
                        " "
                      )}
                      <span className="euro-title-form" id={form.id}>
                        {this.props.t(form.titulo)}
                      </span>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <CardHeader></CardHeader>
                      <CardBody className="col-12">
                        {
                          <div
                            style={{ paddingLeft: "8px" }}
                            className="col-12"
                          >
                            <div
                              style={{ marginTop: "-2em", marginLeft: "-37px" }}
                              className="row "
                            >
                              {form.form}
                            </div>
                          </div>
                        }
                      </CardBody>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Card>
              );
            })
          : false}

        <div id="loaderActive" style={{ display: "none" }}>
          <Loader />
        </div>

        <div hidden={!isEdit} className="col-md-12 divcenter row">
          <div className="col-xs-12 col-md-2 col-lg-2 divcenter">
            <Button
              color="secondary"
              block
              onClick={() => this.props.cancelar()}
              className="m-1"
            >
              {this.props.t("cancel")}
            </Button>
          </div>
          <div className="col-xs-12 col-md-2 col-lg-2 divcenter">
            <Button
              color="primary"
              block
              onClick={() =>
                buttonCheckValidateActive
                  ? this.validateTransPlan(statusId)
                  : ""
              }
              className="m-1"
            >
              {this.props.t("update")}
            </Button>
          </div>
          <div
            hidden={statusId === 2 ? true : false}
            className="col-xs-12 col-md-2 col-lg-2"
          >
            <Button
              color="primary"
              block
              onClick={() =>
                buttonCheckValidateActive ? this.validateTransPlan(2) : ""
              }
              className="m-1"
            >
              {this.props.t("create_transport_plan")}
            </Button>
          </div>
        </div>

        <Modal
          title=""
          centered
          visible={visible}
          bodyStyle={{ height: "38 em" }}
          closable={false}
          width={1250}
          footer={null}
        >
          <div className="modal-transfer-header">
            <h4 className="modal-transfer-title">
              {poActive
                ? this.props.t("purchase_order")
                : this.props.t("request")}
            </h4>
            <div className="modal-transfer-divider" />
          </div>
          {poActive ? (
            <div className=" row" style={{ marginBottom: "5em" }}>
              <div className="col-md-5">
                {/* Título */}
                <div style={{ marginBottom: "1em" }}>
                  <span className="euro-title-form">
                    {this.props.t("purchase_orders_available")}
                  </span>
                </div>
                {/* Search */}
                <div className="spaceDivSearch">
                  <InputGroup>
                    <Input
                      placeholder={this.props.t("search_order_item")}
                      onChange={(e) =>
                        this.setState({ leftSearch: e.target.value })
                      }
                      value={leftSearch}
                    />
                  </InputGroup>
                </div>
                {/* Tabla */}
                <div className="transfer-count">
                  {filteredLeftData.length} {this.props.t("request_lowcap")}
                </div>
                <TableCheckComponent
                  rowKey="POItemsId"
                  preserveSelectedRowKeys
                  pagination={false}
                  dataSource={filteredLeftData}
                  columns={columnAnt}
                  scroll={
                    filteredLeftData.length > 0 ? scrollTableFilter : { x: 800 }
                  }
                  rowSelection={{
                    selectedRowKeys: leftSelectedKeys,
                    type: "checkbox",
                    onChange: this.onSelectLeft,
                    getCheckboxProps: (record) => ({
                      disabled:
                        record.name === "Disabled User" || !record.QTYConfirmed,
                      POItemsId: record.POItemsId,
                    }),
                  }}
                />
                <p className="disabled-message">
                  {this.props.t("disabled-message-transport-plan-check")}
                </p>
              </div>

              <div className="col-md-2 d-flex align-items-center justify-content-center">
                <div className="w-100 text-center">
                  <Button
                    color="primary"
                    className="custom-width-btn mb-3"
                    onClick={() => this.addPOPurchaseOrdeAvaiable()}
                  >
                    {this.props.t("add")}
                  </Button>

                  <Button
                    color="secondary"
                    className="custom-width-btn"
                    onClick={() => this.removePOPurchaseOrdeAvaiable()}
                  >
                    {this.props.t("eliminate")}
                  </Button>
                </div>
              </div>

              <div className="col-md-5">
                <div style={{ marginBottom: "1em" }}>
                  <span className="euro-title-form">
                    {this.props.t("purchase_orders_add")}
                  </span>
                </div>

                <div className="spaceDivSearch">
                  <InputGroup>
                    <Input
                      placeholder={this.props.t("search_order_item")}
                      onChange={(e) =>
                        this.setState({ rightSearch: e.target.value })
                      }
                      value={rightSearch}
                    />
                  </InputGroup>
                </div>
                <div className="transfer-count">
                  {filteredRightData.length} {this.props.t("request_lowcap")}
                </div>
                <TableCheckComponent
                  rowKey="POItemsId"
                  preserveSelectedRowKeys
                  pagination={false}
                  dataSource={filteredRightData}
                  columns={columnAnt}
                  scroll={
                    filteredRightData.length > 0
                      ? scrollTableFilter
                      : { x: 800 }
                  }
                  rowSelection={{
                    selectedRowKeys: rightSelectedKeys,
                    type: "checkbox",
                    onChange: this.onSelectRight,
                    getCheckboxProps: (record) => ({
                      disabled: record.name === "Disabled User",
                      POItemsId: record.POItemsId,
                    }),
                  }}
                />
              </div>
            </div>
          ) : (
            <div className=" row" style={{ marginBottom: "5em" }}>
              <div className="col-md-5">
                <div style={{ marginBottom: "1em" }}>
                  <span className="euro-title-form">
                    {this.props.t("orders_available")}
                  </span>
                </div>

                <div className="spaceDivSearch">
                  <InputGroup>
                    <Input
                      placeholder={this.props.t("search_order")}
                      onChange={(e) =>
                        this.setState({ leftSearch: e.target.value })
                      }
                      value={leftSearch}
                    />
                  </InputGroup>
                </div>
                <div className="transfer-count">
                  {filteredLeftData.length} {this.props.t("request_lowcap")}
                </div>
                <TableCheckComponent
                  rowKey="ServiceOrderId"
                  dataSource={filteredLeftData}
                  columns={columns}
                  preserveSelectedRowKeys
                  pagination={false}
                  scroll={
                    filteredLeftData.length > 0
                      ? scrollTableFilterPoVisibility
                      : { x: 600 }
                  }
                  rowSelection={{
                    selectedRowKeys: leftSelectedKeys,
                    type: "checkbox",
                    onChange: this.onSelectLeft,
                  }}
                />
              </div>

              <div className="col-md-2 d-flex align-items-center justify-content-center">
                <div className="w-100 text-center">
                  <Button block color="primary" onClick={this.addVisibility}>
                    {this.props.t("add")}
                  </Button>
                  <Button
                    block
                    color="secondary"
                    onClick={this.removeVisibility}
                  >
                    {this.props.t("eliminate")}
                  </Button>
                </div>
              </div>
              <div className="col-md-5">
                <div style={{ marginBottom: "1em" }}>
                  <span className="euro-title-form">
                    {this.props.t("added_orders")}
                  </span>
                </div>
                <div className="spaceDivSearch">
                  <InputGroup>
                    <Input
                      placeholder={this.props.t("search_order")}
                      onChange={(e) =>
                        this.setState({ rightSearch: e.target.value })
                      }
                      value={rightSearch}
                    />
                  </InputGroup>
                </div>
                <div className="transfer-count">
                  {filteredRightData.length} {this.props.t("request_lowcap")}
                </div>
                <TableCheckComponent
                  rowKey="ServiceOrderId"
                  dataSource={filteredRightData}
                  columns={columns}
                  preserveSelectedRowKeys
                  pagination={false}
                  scroll={
                    filteredRightData.length > 0
                      ? scrollTableFilterPoVisibility
                      : { x: 600 }
                  }
                  rowSelection={{
                    selectedRowKeys: rightSelectedKeys,
                    type: "checkbox",
                    onChange: this.onSelectRight,
                  }}
                />
              </div>
            </div>
          )}
          <div className="row d-flex justify-content-end">
            <div
              style={{ textAlign: "right" }}
              className="col-xs-12 col-md-4 col-lg-2 m-1"
            >
              <Button block color="secondary" onClick={this.cancelModal}>
                {this.props.t("cancel")}
              </Button>
            </div>
            <div style={{ textAlign: "center" }} className="col-2 divcenter">
              <Button
                block
                color="primary"
                onClick={() =>
                  poActive ? this.handleSavePurchase() : this.handleSave()
                }
              >
                {this.props.t("confirm")}
              </Button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withNamespaces()(withRouter(withStyles(useStyles)(createUsers)));
